import { useTranslate } from "@made-people/grease-translations";

export const ProductDeliveryStatus = ({
  status,
  isImmediateDelivery,
  discontinued,
  inStock,
}: {
  status: string;
  discontinued: boolean;
  inStock: boolean;
  isImmediateDelivery: boolean;
}) => {
  const translate = useTranslate();

  if (discontinued && !inStock) {
    return (
      <div className="text-system-error text-body-sm min-h-5">
        {translate("In_Stock_Message_Product_Is_Discontinued")}
      </div>
    );
  }

  return (
    <div
      className={`text-body-sm min-h-5 ${isImmediateDelivery ? "text-system-success" : "text-system-error"}`}
    >
      {status}
    </div>
  );
};
